import { Controller } from "@hotwired/stimulus";
import channelService from "../services/ChannelService";

export default class extends Controller {
  static values = { channelid: String };

  /* when the channel is shifted on the backend,
     the socket controller is loaded on the front-end
   to reconnect. */

  connect() {
    console.log("Wallet Socket Controller Loaded");
    channelService.connect(this.channelidValue);
  }
}
